import { Box, Typography } from '@mui/material';

import { getOnboardingStatusIcon } from './OnboardingStatusIcon';
import { OnboardingStatusMap } from '../views/FirmBankingView/constants';

const LEGEND_STATUSES = [
  'NOT_STARTED',
  'INVITE_SENT',
  'IN_PROGRESS',
  'BLOCKED',
  'COMPLETED',
  'NOT_APPLICABLE',
] as const;

const OnboardingStatusLegend = () => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'flex-end',
      flexShrink: 0,
    }}
  >
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, auto)',
        columnGap: '24px',
        rowGap: '8px',
        border: '1px solid #06404D',
        borderRadius: '8px',
        padding: '8px 12px',
      }}
    >
      {LEGEND_STATUSES.map((status) => {
        const Icon = getOnboardingStatusIcon(status);
        const { color, label } = OnboardingStatusMap[status];
        return (
          <Box key={status} sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Icon sx={{ color, fontSize: 18 }} />
            <Typography
              sx={{
                fontFamily: 'Inter',
                fontSize: '12px',
                lineHeight: '18px',
                color: 'rgba(255,255,255,0.62)',
                whiteSpace: 'nowrap',
              }}
            >
              {label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  </Box>
);

export default OnboardingStatusLegend;
